

































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';

@Component
export default class SessionReport extends Vue {
  public report: any = {
    babysitter: {
      full_name: '',
    },
    babysitterReport: null,
    session_started_at: '',
    session_ended_at: '',
    hours: 0,
    created_at: '',
    rating: 0,
  };

  public reportLoading: boolean = false;

  @Prop() dialog!: boolean;
  @Prop() sessionId!: any;

  @Watch('dialog')
  onDialogOpen(opened: any) {
    if (opened && this.sessionId) {
      this.loadReport();
    }
  }

  public close() {
    this.$emit('update:dialog', !this.dialog);

    this.reportLoading = true;
  }

  public loadReport() {
    this.reportLoading = true;

    axios
      .get(api.path('v1.admin.sessions.report', { id: this.sessionId }))
      .then((res) => {
        this.report = res.data.data;
        this.reportLoading = false;
      });
  }
}
